module.exports = __webpack_public_path__ + "static/media/lds-logo_ko.8098a63e.svg";